import React from "react";
import { classNames } from "Utils/utils";

const TREND_STYLES = {
  up: "bg-green-50 text-green-700",
  down: "bg-red-50 text-red-700",
  neutral: "bg-gray-100 text-gray-600",
};

const PaMetricCard = ({
  label,
  value,
  trend,
  trendLabel,
  icon = null,
  className,
}) => {
  return (
    <div
      className={classNames(
        "rounded-xl border border-gray-200 bg-white p-5 shadow-sm transition-shadow hover:shadow-md",
        className
      )}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-sm font-medium text-gray-500">{label}</p>
          <p className="mt-2 text-3xl font-semibold tracking-tight text-gray-900">
            {value}
          </p>
          {trendLabel ? (
            <span
              className={classNames(
                "mt-3 inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium",
                TREND_STYLES[trend] || TREND_STYLES.neutral
              )}
            >
              {trendLabel}
            </span>
          ) : null}
        </div>
        {icon ? (
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-indigo-50 text-indigo-600">
            {icon}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PaMetricCard;
